<template>
  <div class="col-md-6">
    <cards class="previews-order-card">
      <div class="wrapper-previews-Item">
        <div class="box avatar image-container">
          <el-image class="logo" :src="order.location.logo">
            <div slot="placeholder" class="image-slot">
              <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"></i>
            </div>
            <div slot="error" class="image-slot text">
              {{ order.location.name.substring(0, 2) | capitalize }}
            </div>
          </el-image>
        </div>
        <div class="box price">
          <p>{{ order.total_price | currency(currentCurrency) }}</p>
        </div>
        <div class="box order-status">
          <div class="order-status-grid">
            <p>{{ getLastStatus(order).text }}</p>
            <span
              :style="{ 'background-color': getLastStatus(order).color }"
              class="grid-dot dot"
            ></span>
          </div>
        </div>
        <div class="box payment_type">
          <i
            :class="
              getHelpers.getPaymentTypeIcon(order.order_payment_type_id, true)
            "
          ></i>
        </div>
        <div class="box date">
          {{
            getHelpers.generateFormatedDateTime(
              order.created_at,
              "date",
              "DD MMM YYYY  HH:mm"
            )
          }}
        </div>
        <div class="box counter">
          <i class="k-icon-basket-2"></i>
          {{ $t("text.counter_items", { counter: order.orderItems.length }) }}
        </div>
        <div class="box items">
          <el-collapse>
            <el-collapse-item>
              <template slot="title"
                ><div
                  v-html="
                    getHelpers.getViewOrderTitle(order.id, order.order_type)
                  "
                ></div
              ></template>
              <div v-for="(item, index) in order.orderItems" :key="index">
                <div v-if="item.menuItem" class="item">
                  <div class="quantity">{{ item.quantity }}</div>
                  <div class="name">{{ item.menuItem.name }}</div>
                  <div class="price">
                    {{
                      getHelpers.getMenuItemPrice(
                        item.menuItem,
                        order.order_type
                      ) | currency(currentCurrency)
                    }}
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div class="box buttons">
        <el-button
          class="col-md-12"
          :disabled="loadingStatus"
          @click="onViewStatusClick(order)"
        >
          <i v-if="loadingStatus" class="k-icon-spin4 animate-spin"></i>
          {{ $t("button.view_status") }}</el-button
        >
      </div>
    </cards>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Button, Cards } from "@/components";
import { helpers, enumHelper } from "@/utilities";

export default {
  name: "current-order-item",
  components: {
    [Button.name]: Button,
    Cards,
  },
  data() {
    return {
      getHelpers: helpers,
      loadingStatus: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    getLastStatus() {
      return (order) => {
        return helpers.getLastOrderStatus({ order_status: order.order_status });
      };
    },
  },
  methods: {
    onViewStatusClick(order) {
      if (order && order.order_status < enumHelper.orderStatus.REJECTED) {
        this.loadingStatus = true;
        let params = {
          order_id: this.order.id,
        };
        this.fetchTrackingOrder(params)
          .then((response) => {
            this.$root.$emit("VIEW_STATUS", response.data);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.loadingStatus = false;
          });
      } else {
        this.$root.$emit("VIEW_STATUS", {
          id: order.id,
          where2_enabled: order.where2_enabled,
          location: order.location,
          orderWhere2: order.orderWhere2,
          order_type: order.order_type,
          order_status: order.order_status,
          orderStatusHistory: order.orderStatusHistory,
        });
      }
    },
  },
  props: {
    order: Object,
    small: Boolean,
  },
};
</script>
